import { useNavigate } from 'react-router-dom';
import { canAccessRoute, useAdminAccess } from '@/shared/model/adminAccess';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';

interface CreateButtonProps {
    navigateTo: string;
    label?: string;
    disabled?: boolean;
    className?: string;
    variant?: 'solid' | 'outline';
    size?: 'small' | 'medium' | 'large';
    fullWidth?: boolean;
}

/** Открывает форму создания, используя общий визуальный контракт кнопок. */
export const CreateButton: React.FC<CreateButtonProps> = (
    {
        navigateTo,
        label = "Создать",
        disabled = false,
        className = '',
        variant = 'solid',
        size = 'medium',
        fullWidth = false
    }
) => {
    const navigate = useNavigate();
    const allowed = useAdminAccess((state) => canAccessRoute(state.snapshot, navigateTo));

    if (!allowed) return null;

    return (
        <ActionButton
            label={label}
            icon="pi pi-plus"
            onClick={() => navigate(navigateTo)}
            disabled={disabled}
            className={className}
            color="primary"
            outlined={variant === 'outline'}
            size={size === 'medium'
                ? undefined
                : size
            }
            fullWidth={fullWidth}
        />
    );
};
